import { Link } from "react-router-dom";
import { Seo } from "@/lib/seo";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#FAF6EF] px-5 text-center" data-testid="notfound-page">
      <Seo title="Page introuvable — Afro Regal" description="La page demandée est introuvable." />
      <p className="font-serif text-7xl font-500 text-[#C9A84C]">404</p>
      <h1 className="mt-4 font-serif text-3xl text-[#2C2C2C]">Cette page n'existe pas</h1>
      <p className="mt-3 max-w-md text-[#2C2C2C]/65">La page que vous recherchez a peut-être été déplacée ou n'existe plus.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Link to="/" className="rounded-full bg-[#2C2C2C] px-7 py-3 text-sm text-white transition-colors hover:bg-[#C9A84C] hover:text-[#2C2C2C]" data-testid="notfound-home">Retour à l'accueil</Link>
        <Link to="/realisations" className="rounded-full border border-[#2C2C2C] px-7 py-3 text-sm text-[#2C2C2C] transition-colors hover:bg-[#2C2C2C] hover:text-white">Nos réalisations</Link>
      </div>
    </div>
  );
}
